(() => {
  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const userAgent = navigator.userAgent || '';
  const lowPowerDevice =
    Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  const problematicWebView =
    (/\bAndroid\b/i.test(userAgent) && /;\s?wv\)/i.test(userAgent)) ||
    /\b(FBAN|FBAV|FB_IAB|FBIOS|Instagram|musical_ly|Bytedance|BytedanceWebview|trill|TikTok)(?:\b|_)/i.test(
      userAgent
    );
  const nativeTransition =
    typeof document.startViewTransition === 'function' &&
    !lowPowerDevice &&
    !problematicWebView;

  if (
    reducedMotion ||
    nativeTransition ||
    root.classList.contains('shopify-design-mode')
  ) {
    root.classList.remove('nx-page-transition-enter');
    return;
  }

  let leaving = false;

  document.addEventListener(
    'click',
    (event) => {
      if (
        leaving ||
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const link = event.target.closest?.('a[href]');

      if (
        !link ||
        link.hasAttribute('download') ||
        link.hasAttribute('data-no-page-transition') ||
        (link.target && link.target !== '_self')
      ) {
        return;
      }

      const destination = new URL(link.href, window.location.href);
      const sameDocumentHash =
        destination.pathname === window.location.pathname &&
        destination.search === window.location.search &&
        destination.hash;

      if (
        destination.origin !== window.location.origin ||
        !['http:', 'https:'].includes(destination.protocol) ||
        destination.href === window.location.href ||
        sameDocumentHash
      ) {
        return;
      }

      event.preventDefault();
      leaving = true;
      root.classList.remove('nx-page-transition-enter');
      root.classList.add('nx-page-transition-leave');

      try {
        sessionStorage.setItem('nexuskin-page-transition', 'enter');
      } catch (error) {
        // Storage can be unavailable in strict privacy modes; the exit still remains graceful.
      }

      window.setTimeout(() => {
        window.location.assign(destination.href);
      }, 240);
    },
    true
  );

  window.setTimeout(() => {
    root.classList.remove('nx-page-transition-enter');
  }, 760);
})();
